export default "/images/pdf-download.svg?ccb59316e1f246bcfad26ee55c9a0102";